"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _BounceLoader = _interopRequireDefault(require("react-spinners/BounceLoader"));
var _theme = require("../theme");
var _loading = _interopRequireDefault(require("../../src/assets/loading.gif"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 *
 * @param {*} param0
 */
var Loader = function Loader(_ref) {
  var classes = _ref.classes,
    customImageStyle = _ref.customImageStyle,
    _ref$whitelabel = _ref.whitelabel,
    whitelabel = _ref$whitelabel === void 0 ? {} : _ref$whitelabel,
    _ref$noGif = _ref.noGif,
    noGif = _ref$noGif === void 0 ? false : _ref$noGif,
    testid = _ref.testid,
    id = _ref.id;
  var styles = {
    loader: {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: _theme.colors.surface,
      opacity: '0.65',
      position: 'absolute',
      textAlign: 'center',
      zIndex: _theme.zIndex.loaderSpinner
    },
    loaderGif: {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: _theme.colors.surface,
      opacity: '1',
      position: 'absolute',
      textAlign: 'center',
      zIndex: _theme.zIndex.loaderBackground
    },
    gif: _objectSpread({
      position: 'absolute',
      top: '50vh',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      height: 200,
      width: 'auto',
      zIndex: _theme.zIndex.loaderBackground
    }, customImageStyle),
    spinner: {
      position: 'absolute',
      top: '50vh',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: _theme.zIndex.loaderSpinner
    }
  };
  if (whitelabel.name && !whitelabel.loader || noGif) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      id: id || testid,
      style: styles.loader
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: styles.spinner
    }, /*#__PURE__*/_react["default"].createElement(_BounceLoader["default"], {
      loading: true,
      color: whitelabel.primaryColor || '#56bfd8',
      size: 50,
      style: customImageStyle || null
    })));
  }
  if (whitelabel.name && whitelabel.loader) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      id: id || testid,
      style: styles.loaderGif
    }, /*#__PURE__*/_react["default"].createElement("img", {
      alt: "".concat(whitelabel.name, " Loader Gif"),
      src: whitelabel.loader,
      style: styles.gif
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id || testid,
    style: styles.loaderGif
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "Simply Benefits Loader Gif",
    src: _loading["default"],
    style: styles.gif
  }));
};
var _default = exports["default"] = Loader;